import { useAppSelector } from '@redux/hooks';
import { getParams, convertorParams, getTemplate, getCurrentPage } from '@entities/Filter';
import { PageUrlConnectionTemplate } from '@entities/Filter/module/types/filterSchema';
import { useDebounce } from '@hooks/useDebounce';

export const useGenerateUrlByParamsFilter = (): {
  fullUrl: string;
  paramsUrl: string;
} => {
  const params = useAppSelector(getParams);
  const page = useAppSelector(getCurrentPage);
  const template = useAppSelector(getTemplate);
  const stringGetParams = useDebounce(convertorParams(params), 500);
  return {
    fullUrl: PageUrlConnectionTemplate[template] + '?' + stringGetParams + `&page=${page}`,
    paramsUrl: stringGetParams,
  };
};
